import { render, staticRenderFns } from "./SBSToken.vue?vue&type=template&id=4e4c9f72&scoped=true"
import script from "./SBSToken.vue?vue&type=script&lang=js"
export * from "./SBSToken.vue?vue&type=script&lang=js"
import style0 from "./SBSToken.vue?vue&type=style&index=0&id=4e4c9f72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c9f72",
  null
  
)

export default component.exports